import { gql } from "@apollo/client";
import UserFragment from "../fragments/User";

// TODO: Trim down this query, some objects being fetched do not seem to be used anymore
const UserQuery = gql`
  query UserWithAssignments($user_token: String!) {
    employer_person(user_token: $user_token) {
      ...UserFields
      token
      phone_number
      email
      ptoUsable
      pto_eligible
      ptoPending
      ptoScheduled
      ptoCompleted
      profile_picture_url(size: 128)
      resume_pdf_url
      staffing_documents {
        id
        name
        kind
        document_fpurl
      }
      benefits_enrollment {
        benefit_guide_url
        completed_enrollment
        eligible
        sequoia_record_exists
        enrolled_medical
        enrolled_dental
        enrolled_vision
        medical_plan_name
        enrolled_anthem_life_add
        enrolled_guardian_life_add
      }
      personal_information {
        id
        phone
        full_address
        preferred_first_name
        firstname
        lastname
        street
        street2
        city
        state
        zip
        country
      }
      active_apps_count
      interviews_count
      onboardings_count
      assignments_count
      employer_onboardings {
        id
        token
        salary
        job {
          id
          name
          staffingConfig: staffing_config {
            id
            holidaysYtdPlusYfn: holidays_ytd_plus_yfn
            holidayPolicy: holiday_policy
            employmentType: employment_type
          }
        }
        complete
        display_start_date
        display_end_date
        pay_rate_access
        has_screening_requirements
        isFailedScreeningResolved
        hasScreeningAccess
        isOnboardingPaused
        all_failed_requirements_accepted
        is_payment_info_complete
        get_substatus
        scheduleType
        showScheduleType
        healthcareEligibility
        offer {
          id
          start_date
          employer_start_date
          work_location
          employer_other_pay_rate
          pay_rate
          pay_frequency
          pay_rate_prefix
          salary
          salary_prefix
          revoked_at
          rejected_at
          usesOffPlatformNegotiations
        }
        assignment {
          id
          token
          active
          permissions
          can @client
          terminated
          wage
          salary
          start_date
          end_date
          status
          pto_available
          token
          title
          pay_display
          work_location
          hours_worked_stats
          sowBadge {
            status
            expirationDate
          }
          employmentType: employment_type
          job {
            id
            employer {
              id
              name
            }
          }
          current_pay_rate_history {
            amount
            started_at
          }
          user {
            id
            pto_eligible
          }
          termination_requests {
            id
            is_employee_notified
            reason
            severance_terms
            severance_payment_amount
            severance_agreement_signature_required
            ha_to_facilitate_equipment_return
            equipment_return_instructions
            is_time_sensitive
            termination_time_instructions
            effective_date
            other_notes
            status
          }
          current_direct_manager {
            id
            token
            full_name
            profile_picture_url
          }
          all_current_managers_at_employer {
            id
            token
            full_name
            email
          }
          department {
            token
            name
          }
          team {
            token
            name
          }
          purchase_orders {
            referenceNumber
            expirationDate
            deptCode
            initialAmount
            token
            startDate
            amountUsed
            active
          }
        }
        screenings {
          id
          report_id
          type
          subtype
          status
          result
        }
        signedDocuments {
          documentType
          name
          source
          status
          downloadUrl
          canGenerate
          signedAt
        }
        i9_verification {
          id
          document_a_name
          document_b_name
          document_c_name
          document_a_fpurl
          document_b_fpurl
          document_c_fpurl
          hellosign_employee_signed_at
          hellosign_hireart_signed_at
          document_fpurl
          is_fully_complete
          candidate_portion_complete
        }
        onboarding_personal_info {
          id
          phone
          full_address
          firstname
          lastname
          emergency_primary_name
          emergency_primary_relationship
          emergency_primary_phone
        }
        trackerProgress {
          onboardingStatus
          onboardingStatusDisplay
          badges {
            name
            status
            completedCount
            totalCount
            requirements {
              name
              status
              complianceVerifications {
                name
                status
              }
            }
          }
        }
        employer_of_record
        hireart_employer_of_record
        bill_rate
        pay_rate
      }
      employer_assignments {
        id
        token
        status
        active
        wage
        salary
        start_date
        end_date
        pto_available
        pay_rate_access
        work_location
        job {
          id
          name
          staffing_config {
            id
            document_templates {
              name
              hellosign_templateid
            }
            document_templates_with_default_requirements {
              name
              hellosign_templateid
            }
          }
          job_requisition {
            id
            position
          }
          staffing_config {
            id
            have_pto_request_enabled
          }
        }
        onboarding {
          id
          membership {
            slug
          }
          background_check_reports {
            id
            package
            status_checkr
            result_checkr
          }
        }
      }
    }
  }
  ${UserFragment}
`;

export default UserQuery;
